// noinspection SuspiciousTypeOfGuard

import { assert } from "@skilitics/nautilus-core-designer-data";

import type { DesignerNode, GetManifestByTypeId } from "../types/index.ts";
import { type GetParentContextById } from "./getNodeParentContext.ts";
import type { GetLayoutTitle } from "./layoutSelectors/index.ts";

interface Options {
  getManifest: GetManifestByTypeId;
  getParentContext: GetParentContextById;
  getLayoutTitle?: GetLayoutTitle;
}

export const getNodeTitleCreate =
  ({ getManifest, getParentContext, getLayoutTitle }: Options) =>
  (node: Omit<DesignerNode, "title">): string => {
    const { id, typeId } = node;
    const manifest = getManifest(typeId);
    const { getTitle } = manifest.designer;
    if (getTitle) {
      const title = getTitle(node, { parentContext: getParentContext(id) });
      assert(
        title === undefined || typeof title === "string",
        `title must be a string ${JSON.stringify(node, undefined, "  ")})}`,
      );
      if (title) return title;
    }
    return getLayoutTitle?.(node) ?? manifest.title;
  };

export type GetNodeTitle = ReturnType<typeof getNodeTitleCreate>;
